import type { IntlShape } from '@formatjs/intl';

export default function priceFormatted(
  intl: { formatNumber: IntlShape['formatNumber'] },
  currency: string,
  price: number,
) {
  return intl.formatNumber(price / 100, { currency, style: 'currency' });
}
